import { useContext } from "react";
import { SupportContext } from "../context";

export const useSupport = () => useContext(SupportContext);
